/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessRecordDto,
  GetRecentRecordAccessesParams,
  ReportRecordAccessRequest
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Log that a user accessed/modified a record.
 * @summary Create Access Log.
 */
export const reportRecordAccess = (
    reportRecordAccessRequest: ReportRecordAccessRequest,
 options?: SecondParameter<typeof apiRequest<void>>,) => {
      return apiRequest<void>(
      {url: `/users/access`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportRecordAccessRequest
    },
      options);
    }
  /**
 * Get access logs for a user.
 * @summary Get Access Logs.
 */
export const getRecentRecordAccesses = (
    params?: GetRecentRecordAccessesParams,
 options?: SecondParameter<typeof apiRequest<AccessRecordDto[]>>,) => {
      return apiRequest<AccessRecordDto[]>(
      {url: `/users/access`, method: 'GET',
        params
    },
      options);
    }
  export type ReportRecordAccessResult = NonNullable<Awaited<ReturnType<typeof reportRecordAccess>>>
export type GetRecentRecordAccessesResult = NonNullable<Awaited<ReturnType<typeof getRecentRecordAccesses>>>
